// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ed-z","heading":"fd-z","items":"gd-z","featureCss":"hd-z","disabled":"id-z","imgCss":"jd-z"};